<div class="table-container" [style.height]="height">
  
  <!-- Loading Overlay -->
  <div *ngIf="loading" class="loading-overlay">
    <div class="spinner"></div>
    <span>Loading...</span>
  </div>

  <!-- Export Buttons -->
  <div *ngIf="enableExport" class="export-controls">
    <button (click)="exportToCsv()" class="btn-export">
      <i class="material-icons">download</i>
      Export CSV
    </button>
  </div>

  <!-- AG Grid -->
  <ag-grid-angular
    #agGrid
    [theme]="customTheme"
    [style.height]="height"
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [gridOptions]="gridOptions"
    [autoSizeStrategy]="autoSizeStrategy"
    [loadingOverlayComponent]="'agLoadingOverlay'"
    [components]="frameworkComponents"
    [suppressLoadingOverlay]="!loading">
  </ag-grid-angular>
  
</div>
